var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertsiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.8791 18H16.1547C16.8142 18 17.4137 17.6628 17.7584 17.0933C18.0956 16.5312 18.1181 15.8418 17.8108 15.2573L10.2421 0.749376C10.0023 0.292256 9.53772 0 9.01315 0C8.49609 0 8.02398 0.284763 7.78418 0.749376L0.215486 15.2573C-0.0917583 15.8418 -0.0692771 16.5312 0.275436 17.0933C0.620148 17.6628 1.21965 18 1.8791 18ZM8.26378 6.75937H9.76253V12.005H8.26378V6.75937ZM9.01315 13.5037C9.42531 13.5037 9.76253 13.841 9.76253 14.2531C9.76253 14.6653 9.42531 15.0025 9.01315 15.0025C8.601 15.0025 8.26378 14.6653 8.26378 14.2531C8.26378 13.841 8.601 13.5037 9.01315 13.5037Z",
    fill: "#D86262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsiteIcon);
export default __webpack_public_path__ + "static/media/Alert site Icon.e4ed5ee4757d40409659681bf359fb4b.svg";
export { ForwardRef as ReactComponent };